import { useEffect, useState, ChangeEvent, useMemo } from 'react';
import { FormControl, NativeSelect } from '@mui/material';
import { FilterButton } from '@care/react-component-lib';
import { Icon24UtilityChevron } from '@care/react-icons';
import { JOB_TYPE_FILTER_OPTIONS } from '@/constants';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { saveFilters } from '../../../utils/filtersStorage';

interface JobTypeFilterProps {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
}

const JobTypeFilter = (props: JobTypeFilterProps) => {
  const defaultState = useMemo(() => ({ jobType: JOB_TYPE_FILTER_OPTIONS.ANY }), []);

  const { handleClick, isClear, onChange } = props;
  const [state, setState] = useState(defaultState);
  const [isSelected, setIsSelected] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setState({ ...state, jobType: event.target.value });
  };

  const iconUtilityChevron = () => (
    <Icon24UtilityChevron component="select" height="20px" width="20px" />
  );
  const handleApply = () => {
    const jobTypeData = {
      jobType: state.jobType,
    };

    setIsSelected(true);
    saveFilters(jobTypeData, onChange);

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, jobTypeData);
  };

  useEffect(() => {
    if (isClear) {
      setState(defaultState);
      setIsSelected(false);
    }
  }, [isClear, defaultState]);

  return (
    <FilterButton
      label="Job Type"
      field="Job Type"
      selected={isSelected}
      onApply={handleApply}
      onClick={handleClick}
      sx={{ color: 'text.primary' }}>
      <FormControl variant="standard" sx={{ width: '325px' }}>
        <NativeSelect
          fullWidth
          IconComponent={iconUtilityChevron}
          onChange={handleChange}
          value={state.jobType}
          inputProps={{
            name: 'jobType',
          }}>
          {Object.entries(JOB_TYPE_FILTER_OPTIONS).map((jobType) => (
            <option key={jobType[0]} value={jobType[0]}>
              {jobType[1]}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    </FilterButton>
  );
};

export default JobTypeFilter;
